import { isFeatureEnabled } from './isFeatureEnabled';

/**
 * Whether this user should be handed off to TungKai. Shared by every entry point that can trigger
 * the hand-off, so none of them can drift out of the homeRedesign rollout.
 *
 * @param {Object} [config] - app config; reads `tungKai.loginUrl` and `tungKai.featureFlags`
 * @param {string} [userId]
 * @returns {boolean}
 */
export const isTungKaiHandOffEnabled = (config, userId) => {
  const featureFlags = config?.tungKai?.featureFlags;

  return (
    !!config?.tungKai?.loginUrl &&
    isFeatureEnabled(featureFlags?.homeRedesign, userId, featureFlags)
  );
};
